//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ActionText, Typography } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import translations from './Header.translations'

export default {
  components: {
    ActionText,
    Typography,
  },

  computed: {
    ...mapGetters({
      isNavigationOpened: 'isNavigationOpened',
    }),
    translations: () => translations,
  },
}
